module.exports = __webpack_public_path__ + "img/society-ashoka-avatar.e191ff3a.png";